export interface Citation {
  title: string
  content: string
  fileId?: string
}

export const MESSAGE_FEEDBACK_RATINGS = ['positive', 'negative'] as const

export type MessageFeedbackRating = (typeof MESSAGE_FEEDBACK_RATINGS)[number]

export const MESSAGE_FEEDBACK_STATUSES = [
  'new',
  'reviewed',
  'actioned',
] as const

export type MessageFeedbackStatus = (typeof MESSAGE_FEEDBACK_STATUSES)[number]

export const MESSAGE_FEEDBACK_POSITIVE_REASONS = [
  { tag: 'sources_useful', label: 'Cited sources were useful' },
  { tag: 'matched_context', label: 'Answer matched my project context' },
  { tag: 'clear_practical', label: 'Clear and practical' },
  {
    tag: 'helped_next_step',
    label: 'Helped me decide what to check next',
  },
  { tag: 'seems_accurate', label: 'Information seemed accurate' },
  { tag: 'other', label: 'Other' },
] as const

export const MESSAGE_FEEDBACK_NEGATIVE_REASONS = [
  {
    tag: 'missing_guidance',
    label: 'Missing relevant regulation or guidance',
  },
  { tag: 'unsupported_answer', label: 'Source did not support the answer' },
  { tag: 'too_vague', label: 'Answer was too vague' },
  { tag: 'misunderstood_context', label: 'Project context was misunderstood' },
  { tag: 'outdated', label: 'Information seems outdated' },
  { tag: 'hard_to_understand', label: 'Hard to understand' },
  { tag: 'other', label: 'Other' },
] as const

export const MESSAGE_FEEDBACK_REASON_TAGS = [
  'sources_useful',
  'matched_context',
  'clear_practical',
  'helped_next_step',
  'seems_accurate',
  'missing_guidance',
  'unsupported_answer',
  'too_vague',
  'misunderstood_context',
  'outdated',
  'hard_to_understand',
  'other',
] as const

export type MessageFeedbackReasonTag =
  (typeof MESSAGE_FEEDBACK_REASON_TAGS)[number]

export const MESSAGE_FEEDBACK_REASON_LABELS = Object.fromEntries(
  [
    ...MESSAGE_FEEDBACK_POSITIVE_REASONS,
    ...MESSAGE_FEEDBACK_NEGATIVE_REASONS,
  ].map((reason) => [reason.tag, reason.label]),
) as Record<string, string>

export interface MessageFeedbackSummary {
  id: string
  rating: MessageFeedbackRating
  reasonTags: Array<MessageFeedbackReasonTag>
  note: string | null
  status: MessageFeedbackStatus
  createdAt?: string | Date | null
  updatedAt?: string | Date | null
}

export interface HistoryMessage {
  role: 'user' | 'assistant'
  content: string
  citations?: Array<Citation>
  feedback?: MessageFeedbackSummary | null
}

export interface ChatResponse {
  text: string
  citations: Array<Citation>
}
